
export type ProductType = string

export const STAFF_TOOLS : ProductType = 'STAFF_TOOLS'
export const POST : ProductType = 'POSTUI3'
export const TOPIC_PULSE: ProductType = 'TOPIC_PULSE'
export const TOPLINE: ProductType = 'TOPLINE'
export const TETHER: ProductType = 'TETHER'
